import { atom } from 'recoil';

import { IS_OPEN_CHAT } from '../constants';

export const AIsOpenChat = atom<boolean>({
  key: IS_OPEN_CHAT,
  default: false,
});
